export default "__VITE_ASSET__BGw5p8Ap__"